module.exports = __webpack_public_path__ + "static/media/andreaBiondi.acffba3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/andreaBiondi.jpg
// module id = 1664
// module chunks = 1